// 지원되는 언어 코드
const SUPPORTED_LANGUAGES = ['ko', 'en', 'id'];

/**
 * 브라우저의 언어 설정을 기반으로 지원되는 언어를 반환
 * @returns {string} 지원되는 언어 코드 (기본값: 'en')
 */
export const getBrowserLanguage = () => {
  // 1. localStorage에서 저장된 언어 설정 확인
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage && SUPPORTED_LANGUAGES.includes(savedLanguage)) {
    return savedLanguage;
  }

  // 2. 브라우저 언어 설정 확인
  const browserLanguage = navigator.language || navigator.userLanguage;
  
  if (!browserLanguage) {
    return 'en'; // 기본값
  }

  // 3. 언어 코드에서 기본 언어 부분만 추출 (예: 'ko-KR' -> 'ko')
  const primaryLanguage = browserLanguage.split('-')[0].toLowerCase();
  
  // 4. 지원되는 언어인지 확인
  if (SUPPORTED_LANGUAGES.includes(primaryLanguage)) {
    return primaryLanguage;
  }

  // 5. 지원되지 않는 언어인 경우 영어로 설정
  return 'en';
};

/**
 * 언어 코드를 표시용 라벨로 변환
 * @param {string} languageCode - 언어 코드
 * @returns {string} 표시용 라벨
 */
export const getLanguageLabel = (languageCode) => {
  const languageMap = {
    'ko': '한국어',
    'en': 'English',
    'id': 'Bahasa Indonesia'
  };
  
  return languageMap[languageCode] || 'English';
};
